import { Link } from 'react-router'
import qs from 'query-string'
import { getCustomer } from 'helpers'

const InternalLink = ({ to, children, ...props }) => {
  const parsed = qs.parseUrl(to)
  const newQuery = { ...parsed.query, customer: getCustomer() }
  const newUrl = `${parsed.url}?${qs.stringify(newQuery)}`

  return (
    <Link {...props} to={newUrl}>
      {children}
    </Link>
  )
}

export default InternalLink
